// Faza 6.2.23 (2026-05-03): split z customers.ts — see .plans/audit-customers-split.md
// Sesja 3.5 (2026-05-03): migracja na Nanostores dla customers state

import type { CustomerRow, ApiError } from '../../types/dto.ts';


import { wartosciFormularza } from '../form-values.ts';
// Lazy delegates (Faza 6.2.23 — cross-module deps)
function _nipInitInlineButton(this: any, ...args: any[]): any { return ((window.__sbExports && window.__sbExports._nipInitInlineButton) || window._nipInitInlineButton).apply(this, args); }
function _nipInitAutoLookup(this: any, ...args: any[]): any { var f: any = (window.__sbExports && (window.__sbExports as any)._nipInitAutoLookup) || (window as any)._nipInitAutoLookup; return typeof f === 'function' ? f.apply(this, args) : undefined; }
function closeModal(this: any, ...args: any[]): any { return (((window.__sbExports && window.__sbExports.closeModal) || window.closeModal) as any).apply(this, args); }
function navigate(this: any, ...args: any[]): any { return (((window.__sbExports && window.__sbExports.navigate) || window.navigate) as any).apply(this, args); }
function openModal(this: any, ...args: any[]): any { return (((window.__sbExports && window.__sbExports.openModal) || window.openModal) as any).apply(this, args); }

// Cross-file delegates (Faza 6.2.23 — między customers/* files)
function openCustomerModal(this: any, ...args: any[]): any { return ((window.__sbExports && window.__sbExports.openCustomerModal) || window.openCustomerModal).apply(this, args); }
function renderCustomers(this: any, ...args: any[]): any { return ((window.__sbExports && window.__sbExports.renderCustomers) || window.renderCustomers).apply(this, args); }


function showCustomerModal(existingCustomer: CustomerRow | null | undefined, onSaved?: (saved: CustomerRow) => void) {
    var isEdit = !!existingCustomer;
    var c: Partial<CustomerRow> = existingCustomer || {};
    var isCompany = c.type === 'company';

    // Czy adres faktury różni się od dostawy?
    var diffInvoice = !!(c.invoice_street && c.invoice_street !== c.delivery_street);

    var statuses = SellBaseData.customerStatuses;
    var statusOptions = statuses.map(function(s: { key?: string; label?: string; [k: string]: unknown }) {
      return '<option value="' + s.key + '"' + (c.status === s.key ? ' selected' : '') + '>' + escapeHtml(s.label) + '</option>';
    }).join('');

    var countries = [
      { code: 'PL', name: 'Polska' }, { code: 'DE', name: 'Niemcy' },
      { code: 'CZ', name: 'Czechy' }, { code: 'SK', name: 'S\u0142owacja' },
      { code: 'HU', name: 'W\u0119gry' }, { code: 'GB', name: 'Wielka Brytania' },
      { code: 'FR', name: 'Francja' }, { code: 'IT', name: 'W\u0142ochy' }
    ];
    function countrySelect(name: string, val: string | null | undefined) {
      return '<select class="form-select" name="' + name + '">' +
        countries.map(function(cn) {
          return '<option value="' + cn.code + '"' + ((val || 'PL') === cn.code ? ' selected' : '') + '>' + escapeHtml(cn.name) + '</option>';
        }).join('') + '</select>';
    }

    var body = '' +
      // Type toggle
      '<div style="display:flex;gap:8px;margin-bottom:16px">' +
        '<button type="button" class="btn-ghost customer-type-btn' + (!isCompany ? ' active' : '') + '" data-ctype="individual" style="flex:1;padding:10px;border-radius:8px' + (!isCompany ? ';background:var(--color-surface-2)' : '') + '">' +
          '<i data-lucide="user" style="width:16px;height:16px"></i> Osoba fizyczna' +
        '</button>' +
        '<button type="button" class="btn-ghost customer-type-btn' + (isCompany ? ' active' : '') + '" data-ctype="company" style="flex:1;padding:10px;border-radius:8px' + (isCompany ? ';background:var(--color-surface-2)' : '') + '">' +
          '<i data-lucide="building-2" style="width:16px;height:16px"></i> Firma' +
        '</button>' +
      '</div>' +

      '<form class="settings-form" id="customer-form">' +
        '<input type="hidden" name="type" value="' + (c.type || 'individual') + '">' +

        // Pola tylko dla firm
        '<div id="company-field-wrap" style="' + (isCompany ? '' : 'display:none') + '">' +
          '<div class="form-row">' +
            '<div class="form-group"><label>Nazwa firmy</label>' +
              '<input type="text" class="form-input" name="company_name" value="' + escapeAttr(c.company_name || '') + '" placeholder="Nazwa firmy">' +
            '</div>' +
            '<div class="form-group"><label>NIP</label>' +
              '<div style="position:relative"><input type="text" class="form-input" id="cust-nip" name="nip" value="' + escapeAttr(c.nip || '') + '" placeholder="NIP firmy"></div>' +
            '</div>' +
          '</div>' +
        '</div>' +

        // Imię / Nazwisko — dla firm jako "Osoba kontaktowa" (opcjonalne)
        '<div id="first-last-row" class="form-row">' +
          '<div class="form-group"><label id="first-name-label">Imi\u0119' + (!isCompany ? '' : ' <span style="font-weight:400;font-size:0.8em;color:var(--color-text-faint)">(kontakt)</span>') + '</label>' +
            '<input type="text" class="form-input" name="first_name" value="' + escapeAttr(c.first_name || '') + '">' +
          '</div>' +
          '<div class="form-group"><label id="last-name-label">Nazwisko' + (!isCompany ? '' : ' <span style="font-weight:400;font-size:0.8em;color:var(--color-text-faint)">(kontakt)</span>') + '</label>' +
            '<input type="text" class="form-input" name="last_name" value="' + escapeAttr(c.last_name || '') + '">' +
          '</div>' +
        '</div>' +
        '<div class="form-row">' +
          '<div class="form-group"><label>E-mail</label>' +
            '<input type="email" class="form-input" name="email" value="' + escapeAttr(c.email || '') + '" required>' +
          '</div>' +
          '<div class="form-group"><label>Telefon</label>' +
            '<input type="tel" class="form-input" name="phone" value="' + escapeAttr(c.phone || '') + '">' +
          '</div>' +
        '</div>' +
        '<div class="form-group"><label>Status</label>' +
          '<select class="form-select" name="status">' + statusOptions + '</select>' +
        '</div>' +

        // Adres dostawy
        '<h4 style="margin:16px 0 8px;font-size:0.9em;color:var(--color-text-muted)"><i data-lucide="truck" style="width:14px;height:14px;vertical-align:middle"></i> Adres dostawy</h4>' +
        // Wiersz odbiorca + firma — tylko dla firm
        '<div id="del-name-company-row" class="form-row" style="' + (isCompany ? '' : 'display:none') + '">' +
          '<div class="form-group"><label>Imi\u0119 i nazwisko odbiorcy</label>' +
            '<input type="text" class="form-input" name="delivery_name" value="' + escapeAttr(c.delivery_name || '') + '">' +
          '</div>' +
          '<div class="form-group"><label>Firma</label>' +
            '<input type="text" class="form-input" name="delivery_company" value="' + escapeAttr(c.delivery_company || '') + '">' +
          '</div>' +
        '</div>' +
        '<div class="form-group"><label>Ulica i nr</label>' +
          '<input type="text" class="form-input" name="delivery_street" value="' + escapeAttr(c.delivery_street || '') + '">' +
        '</div>' +
        '<div class="form-row">' +
          '<div class="form-group"><label>Kod pocztowy</label>' +
            '<input type="text" class="form-input" name="delivery_postal_code" value="' + escapeAttr(c.delivery_postal_code || '') + '" placeholder="XX-XXX">' +
          '</div>' +
          '<div class="form-group"><label>Miasto</label>' +
            '<input type="text" class="form-input" name="delivery_city" value="' + escapeAttr(c.delivery_city || '') + '">' +
          '</div>' +
        '</div>' +
        '<div class="form-row">' +
          '<div class="form-group"><label>Wojew\u00f3dztwo / Region</label>' +
            '<input type="text" class="form-input" name="delivery_province" value="' + escapeAttr(c.delivery_province || '') + '">' +
          '</div>' +
          '<div class="form-group"><label>Kraj</label>' +
            countrySelect('delivery_country', c.delivery_country) +
          '</div>' +
        '</div>' +

        // Checkbox — dane do faktury inne niż dostawa
        '<div style="margin:14px 0 4px;display:flex;align-items:center;gap:8px">' +
          '<input type="checkbox" id="diff-invoice-chk" name="diff_invoice" value="1"' + (diffInvoice ? ' checked' : '') + ' style="width:15px;height:15px;cursor:pointer;accent-color:var(--color-primary)">' +
          '<label for="diff-invoice-chk" style="cursor:pointer;font-size:0.88em;color:var(--color-text-muted);user-select:none">' +
            '<i data-lucide="receipt" style="width:13px;height:13px;vertical-align:middle;margin-right:4px"></i>' +
            'Dane do faktury inne ni\u017c adres dostawy' +
          '</label>' +
        '</div>' +

        // Sekcja faktury — widoczna gdy checkbox zaznaczony
        '<div id="invoice-section" style="' + (diffInvoice ? '' : 'display:none') + ';border-left:3px solid var(--color-border);padding-left:12px;margin-top:8px">' +
          // Wiersz odbiorca + firma — tylko dla firm
          '<div id="inv-name-company-row" class="form-row" style="' + (isCompany ? '' : 'display:none') + '">' +
            '<div class="form-group"><label>Imi\u0119 i nazwisko</label>' +
              '<input type="text" class="form-input" name="invoice_name" value="' + escapeAttr(c.invoice_name || '') + '">' +
            '</div>' +
            '<div class="form-group"><label>Firma</label>' +
              '<input type="text" class="form-input" name="invoice_company" value="' + escapeAttr(c.invoice_company || '') + '">' +
            '</div>' +
          '</div>' +
          '<div class="form-group"><label>Ulica i nr</label>' +
            '<input type="text" class="form-input" name="invoice_street" value="' + escapeAttr(c.invoice_street || '') + '">' +
          '</div>' +
          '<div class="form-row">' +
            '<div class="form-group"><label>Kod pocztowy</label>' +
              '<input type="text" class="form-input" name="invoice_postal_code" value="' + escapeAttr(c.invoice_postal_code || '') + '">' +
            '</div>' +
            '<div class="form-group"><label>Miasto</label>' +
              '<input type="text" class="form-input" name="invoice_city" value="' + escapeAttr(c.invoice_city || '') + '">' +
            '</div>' +
          '</div>' +
          '<div class="form-row">' +
            '<div class="form-group"><label>Wojew\u00f3dztwo / Region</label>' +
              '<input type="text" class="form-input" name="invoice_province" value="' + escapeAttr(c.invoice_province || '') + '">' +
            '</div>' +
            '<div class="form-group"><label>Kraj</label>' +
              countrySelect('invoice_country', c.invoice_country) +
            '</div>' +
          '</div>' +
        '</div>' +

        // Notatki
        '<div class="form-group" style="margin-top:12px"><label>Notatki</label>' +
          '<textarea class="form-input" name="notes" rows="3" style="resize:vertical">' + escapeHtml(c.notes || '') + '</textarea>' +
        '</div>' +
      '</form>';

    var footer = '<button class="btn-ghost" onclick="SellBaseApp.closeModal()">Anuluj</button>' +
      '<button class="btn-primary" id="save-customer-btn">' +
        '<i data-lucide="check" style="width:14px;height:14px"></i> ' + (isEdit ? 'Zapisz zmiany' : 'Dodaj klienta') +
      '</button>';

    openModal((isEdit ? 'Edytuj klienta' : 'Nowy klient'), body, footer, 'lg');

    setTimeout(function() {
      var typeBtns = document.querySelectorAll('.customer-type-btn');
      var companyWrap = document.getElementById('company-field-wrap');
      var delNameRow = document.getElementById('del-name-company-row');
      var invNameRow = document.getElementById('inv-name-company-row');
      var typeInput = document.querySelector('#customer-form input[name="type"]');
      var firstNameLabel = document.getElementById('first-name-label');
      var lastNameLabel = document.getElementById('last-name-label');
      var contactSuffix = ' <span style="font-weight:400;font-size:0.8em;color:var(--color-text-faint)">(kontakt)</span>';

      typeBtns.forEach(function(btn) {
        btn.addEventListener('click', function(this: any) {
          typeBtns.forEach(function(b: any) { b.classList.remove('active'); b.style.background = ''; });
          this.classList.add('active');
          this.style.background = 'var(--color-surface-2)';
          var ctype = this.dataset.ctype;
          (typeInput as any).value = ctype;
          var isC = ctype === 'company';
          (companyWrap as any).style.display = isC ? '' : 'none';
          (delNameRow as any).style.display = isC ? '' : 'none';
          if (invNameRow) invNameRow.style.display = isC ? '' : 'none';
          if (firstNameLabel) firstNameLabel.innerHTML = 'Imi\u0119' + (isC ? contactSuffix : '');
          if (lastNameLabel) lastNameLabel.innerHTML = 'Nazwisko' + (isC ? contactSuffix : '');
        });
      });

      // NIP lookup for customer
      // 2026-09-03 (user): po wpisaniu NIP dane z GUS uzupełniają wszystko, co się da —
      // nazwę (nadpisujemy), firmę odbiorcy, adres dostawy z krajem PL i dane do faktury.
      // Pola wpisane ręcznie (poza nazwą) zostają; automat odpala się po 10 cyfrach.
      _nipInitInlineButton('cust-nip', function(data: { name?: string; address?: { street?: string; city?: string; postal_code?: string; zip?: string }; [k: string]: unknown }) {
        var f = document.getElementById('customer-form');
        if (!f) return;
        var set = function(name: string, val: unknown, nadpisz?: boolean) {
          var el = f!.querySelector('[name="' + name + '"]') as any;
          if (!el || val == null || !String(val).trim()) return;
          if (nadpisz || !String(el.value || '').trim()) el.value = String(val).trim();
        };
        var kraj = function(name: string) {
          var el = f!.querySelector('select[name="' + name + '"]') as any;
          if (!el) return;
          for (var i = 0; i < el.options.length; i++) { if (el.options[i].value === 'PL') { el.selectedIndex = i; break; } }
        };
        var adr: any = (data.address && typeof data.address === 'object') ? data.address : {};
        set('company_name', data.name, true);
        set('delivery_company', data.name);
        set('delivery_street', adr.street); set('delivery_postal_code', adr.postal_code || adr.zip); set('delivery_city', adr.city);
        if (adr.street || adr.city) kraj('delivery_country');
        set('invoice_company', data.name);
        set('invoice_street', adr.street); set('invoice_postal_code', adr.postal_code || adr.zip); set('invoice_city', adr.city);
        if (adr.street || adr.city) kraj('invoice_country');
      });
      _nipInitAutoLookup('cust-nip');

      // Checkbox: dane do faktury inne niż dostawa
      var diffChk = document.getElementById('diff-invoice-chk');
      var invoiceSection = document.getElementById('invoice-section');
      if (diffChk && invoiceSection) {
        diffChk.addEventListener('change', function(this: any) {
          (invoiceSection as any).style.display = this.checked ? '' : 'none';
        });
      }

      // Save
      var saveBtn = document.getElementById('save-customer-btn');
      if (saveBtn) {
        saveBtn.addEventListener('click', function() {
          var form = document.getElementById('customer-form');
          // 2026-08-25: odczyt odporny na anty-autofill (patrz form-values.ts) —
          // pola adresowe klienta traciły `name` i zapis szedł bez nich.
          var data: Record<string, any> = wartosciFormularza(form as any);

          // Walidacja według typu
          if (data.type === 'company') {
            if (!data.company_name) { showToast('Wpisz nazw\u0119 firmy', 'error'); return; }
          } else {
            if (!data.first_name || !data.last_name) { showToast('Wpisz imi\u0119 i nazwisko', 'error'); return; }
          }
          if (!data.email) { showToast('Wpisz adres e-mail', 'error'); return; }

          var savePayload: Record<string, unknown> = {
            type: data.type || 'individual',
            status: data.status || 'standard',
            login: c.login || '',
            first_name: data.first_name || '',
            last_name: data.last_name || '',
            company_name: data.company_name || '',
            nip: data.nip || '',
            email: data.email || '',
            phone: data.phone || '',
            delivery_name: data.delivery_name || '',
            delivery_company: data.delivery_company || '',
            delivery_street: data.delivery_street || '',
            delivery_postal_code: data.delivery_postal_code || '',
            delivery_city: data.delivery_city || '',
            delivery_province: data.delivery_province || '',
            delivery_country: data.delivery_country || 'PL',
            notes: data.notes || ''
          };

          // Adres faktury: skopiuj z dostawy gdy checkbox odznaczony
          if (data.diff_invoice) {
            savePayload.invoice_name    = data.invoice_name || '';
            savePayload.invoice_company = data.invoice_company || '';
            savePayload.invoice_street  = data.invoice_street || '';
            savePayload.invoice_postal_code = data.invoice_postal_code || '';
            savePayload.invoice_city    = data.invoice_city || '';
            savePayload.invoice_province = data.invoice_province || '';
            savePayload.invoice_country = data.invoice_country || 'PL';
            savePayload.invoice_nip     = data.nip || '';
          } else {
            savePayload.invoice_name    = savePayload.delivery_name;
            savePayload.invoice_company = savePayload.delivery_company;
            savePayload.invoice_street  = savePayload.delivery_street;
            savePayload.invoice_postal_code = savePayload.delivery_postal_code;
            savePayload.invoice_city    = savePayload.delivery_city;
            savePayload.invoice_province = savePayload.delivery_province;
            savePayload.invoice_country = savePayload.delivery_country;
            savePayload.invoice_nip     = savePayload.nip;
          }

          (saveBtn as any).disabled = true;
          (saveBtn as any).innerHTML = '<i data-lucide="loader-2" style="width:14px;height:14px"></i> Zapisywanie...';
          lucide.createIcons();
          var req = isEdit
            ? SellBaseAPI.updateCustomer(existingCustomer!.id, savePayload)
            : SellBaseAPI.createCustomer(savePayload);
          req.then(function(saved: CustomerRow) {
            closeModal();
            // AUDYT 2026-08-11: liczniki sidebar + auto-cache listy — bez tego stan sprzed zapisu do F5
            try { var _f = (window as any).__sbOdswiezKlientow; if (typeof _f === 'function') _f(); } catch (_e) {}
            showToast(isEdit ? 'Klient zaktualizowany' : 'Klient dodany', 'success');
            if (typeof onSaved === 'function') {
              onSaved(saved);
              return;
            }
            if (isEdit) {
              openCustomerModal(saved.id || existingCustomer!.id);
            } else {
              navigate('/customers');
              renderCustomers();
            }
          }).catch(function(err: ApiError) {
            (saveBtn as any).disabled = false;
            (saveBtn as any).innerHTML = '<i data-lucide="check" style="width:14px;height:14px"></i> ' + (isEdit ? 'Zapisz zmiany' : 'Dodaj klienta');
            lucide.createIcons();
            showToast(err.message || 'Nie uda\u0142o si\u0119 zapisa\u0107 klienta', 'error');
          });
        });
      }
    }, 50);
}

// ── EXPOSE: extracted functions ──
(window as any).SellBaseApp = (window as any).SellBaseApp || {};
window.showCustomerModal = showCustomerModal; window.SellBaseApp.showCustomerModal = showCustomerModal;

// ── ES Module exports ──
export {
  showCustomerModal,
};
